import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./pagenotfound.css";


export default function PageNotFound() {

    const url = useLocation().search;//.pathname.split("/");
    
    // const urlPath = url[1];
    useEffect(() => {
        window.top.postMessage(window.location.href, "*");
    }, []);

    //process.env.REACT_APP_EXPRESSMINI_REDIRECT_URL
    return <h1 className="text-center">{(url === "") ? "Page Not Found" : ""}</h1>
}